import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/settings/point-of-sale')({
	staticData: { crumb: ({ context: { L } }) => L.Settings.PointOfSale.Title() }
})
